import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectIsMobile } from 'redux/mode/reducers';
import { RootReducer } from 'redux/reducers';

// Manages dropdown open/close state with click-outside dismissal
// and auto-close when the sidebar hides (transient mode).
const useSidebarDropdown = () => {
	const [isOpen, setIsOpen] = useState(false);
	const containerRef = useRef<HTMLDivElement>(null);

	const sidebarVisible = useSelector((r: RootReducer) =>
		selectIsMobile(r.mode)
			? r.mode.sidebarVisible
			: r.mode.sidebarDocked || r.mode.sidebarHovered
	);

	// Close when sidebar hides
	useEffect(() => {
		if (!sidebarVisible) setIsOpen(false);
	}, [sidebarVisible]);

	// Close on click outside
	useEffect(() => {
		const onMouseDown = (e: MouseEvent) => {
			if (containerRef.current && !containerRef.current.contains(e.target as Node)) {
				setIsOpen(false);
			}
		};
		if (isOpen) {
			document.addEventListener('mousedown', onMouseDown);
		}
		return () => document.removeEventListener('mousedown', onMouseDown);
	}, [isOpen]);

	const toggle = () => setIsOpen((v) => !v);
	const close = () => setIsOpen(false);

	return { isOpen, toggle, close, containerRef };
};

export default useSidebarDropdown;
